import type { ColorToken, TaskDTO } from '@hearth/shared';
import { clsx } from 'clsx';
import { Repeat, StickyNote, Users } from 'lucide-react';
import { calendarBlockClasses } from '../../lib/colors';

/** Fill of a block, bar or note chip: its color, a left stripe (a dashed outline for notes), faded when done. */
export function entryFillClass(task: TaskDTO, color: ColorToken, selected: boolean): string {
  return clsx(
    calendarBlockClasses(color),
    task.type === 'note' ? 'border border-dashed' : 'border-l-[3px]',
    task.status === 'completed' && 'opacity-60',
    selected && 'ring-2 ring-ember-500 ring-offset-1 ring-offset-surface',
  );
}

/** Small markers after the title: note, repeating, has guests. Decorative — the accessible name says it all. */
export function EntryIcons({ task, size = 11 }: { task: TaskDTO; size?: number }) {
  return (
    <>
      {task.type === 'note' && <StickyNote size={size} aria-hidden className="shrink-0 opacity-80" />}
      {task.seriesId && <Repeat size={size} aria-hidden className="shrink-0 opacity-80" />}
      {task.attendeeIds.length > 0 && <Users size={size} aria-hidden className="shrink-0 opacity-80" />}
    </>
  );
}

export function OverdueDot() {
  return <span aria-hidden title="Overdue" className="size-1.5 shrink-0 rounded-full bg-red-500" />;
}
